module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "mobileDeviceViewing col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.workflow.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.workflow.description))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.workflow.active == true ? 'Active' : 'Inactive'))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workflow.ranger),
      expression: "!workflow.ranger"
    }]
  }, [_vm._v(_vm._s(_vm.workflow.critical == false ? 'Non Critical' : 'Critical'))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workflow.ranger),
      expression: "!workflow.ranger"
    }]
  }, [_vm._v(_vm._s(_vm.workflow.endtimebased == false ? 'Start Time Based' : 'End Time Based'))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workflow.ranger),
      expression: "!workflow.ranger"
    }]
  }, [_vm._v("Schedule: " + _vm._s(_vm.workflow.schedule) + " Minutes")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workflow.ranger),
      expression: "!workflow.ranger"
    }]
  }, [_vm._v("Warn Before: " + _vm._s(_vm.workflow.warnBefore) + " Minutes")]), _vm._v(" "), _c('p', [_vm._v("Last Completed: " + _vm._s(_vm.filteredData.lastcompleted))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workflow.ranger),
      expression: "!workflow.ranger"
    }]
  }, [_vm._v("Next Due: " + _vm._s(_vm.filteredData.nextdue))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workflow.ranger),
      expression: "!workflow.ranger"
    }],
    staticClass: "col-md-5 offset-md-1"
  }, [_c('h5', [_vm._v("Tasks")]), _vm._v(" "), (_vm.org['curOrg']['role'] == 99) ? _c('div', [(!_vm.tasksJsonView) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.tasksJsonView = true
      }
    }
  }, [_vm._v("JSON View")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.tasksJsonView = false
      }
    }
  }, [_vm._v("Normal View")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.tasks.length - 1) + " Tasks")]), _vm._v(" "), (!_vm.tasksJsonView) ? _c('div', _vm._l((_vm.tasks), function(task) {
    return _c('div', {
      staticClass: "list-group"
    }, _vm._l((task), function(element) {
      return _c('div', {
        staticClass: "list-group-item"
      }, [(element.name == 'Location Tag') ? _c('div', [_c('div', {
        staticClass: "d-flex w-100 justify-content-between"
      }, [_c('p', {
        staticStyle: {
          "font-size": "15px"
        }
      }, [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('small', [_vm._v("Speak Text: " + _vm._s(element.speak))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {}, [_vm._v("Tag Name: " + _vm._s(element.description))])]) : (element.name == 'Input') ? _c('div', [_c('div', {
        staticClass: "d-flex w-100 justify-content-between"
      }, [_c('p', {
        staticStyle: {
          "font-size": "15px"
        }
      }, [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('small', [_vm._v("Type: " + _vm._s(_vm.inputTypes.find(function(inputType) {
        return inputType['.key'] == element.type
      })['name']))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {}, [_vm._v("Name: " + _vm._s(element.description))])]) : (element.name == 'Temperature') ? _c('div', [_c('div', {
        staticClass: "d-flex w-100 justify-content-between"
      }, [_c('p', {
        staticStyle: {
          "font-size": "15px"
        }
      }, [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('small', {}, [_vm._v("Name: " + _vm._s(element.description))])]) : _vm._e()])
    }), 0)
  }), 0) : _c('div', [_c('pre', [_vm._v(_vm._s(_vm._f("pretty")(_vm.tasks)))])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f5a6220","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/ArchivedWorkflows/ArchivedWorkflowDetail.vue
// module id = 622
// module chunks = 1